/* Disponibilidad en el selector de cantidad (Sirena, 2026-09-22).
   Dice cuántas unidades quedan, cuántas ya están en el carrito y no deja pedir de más,
   para evitar los mensajes de Shopify "Debido a la disponibilidad, solo se añadió un
   artículo al carrito" y "Tu carrito ya tiene la cantidad máxima de este artículo". */
(function () {
  'use strict';
  var data = {};
  try { data = JSON.parse(document.querySelector('[data-sirena-stock]').textContent); } catch (e) { return; }

  var form = document.querySelector('.product-block-list__item--info form[action*="/cart/add"]') ||
             document.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  var input = form.querySelector('[name="quantity"]');
  var selector = input && input.closest('.quantity-selector');
  if (!input || !selector) return;
  var boton = form.querySelector('.product-form__add-button, [type="submit"]');

  var aviso = document.createElement('p');
  aviso.className = 'sst sst--info';
  aviso.setAttribute('role', 'status');
  selector.parentNode.insertBefore(aviso, selector.nextSibling);

  var enCarrito = {};
  var avisoHasta = 0;   // deja el aviso rojo unos segundos tras recortar la cantidad

  function idActual() {
    var i = form.querySelector('[name="id"]');
    return i ? String(i.value) : '';
  }
  function datos() { return data[idActual()] || null; }
  function limitado(v) { return v && v.t && v.d; }       // con control de stock y sin venta a pedido
  function unidades(n) { return n === 1 ? 'unidad' : 'unidades'; }

  function pintar(v, restante, ajustado) {
    if (!limitado(v) || v.q <= 0) { aviso.textContent = ''; return; }
    var ya = enCarrito[idActual()] || 0;
    if (restante <= 0) {
      aviso.className = 'sst sst--tope';
      aviso.textContent = 'Ya tienes en tu carrito las ' + v.q + ' ' + unidades(v.q) + ' disponibles.';
    } else if (ajustado) {
      aviso.className = 'sst sst--tope';
      aviso.textContent = 'Solo puedes llevar ' + restante + ' ' + unidades(restante) +
        (ya ? ' más (ya tienes ' + ya + ' en el carrito).' : '.');
    } else if (ya) {
      aviso.className = 'sst sst--pocas';
      aviso.textContent = 'Quedan ' + v.q + ' ' + unidades(v.q) + ' · ya tienes ' + ya + ' en tu carrito, puedes llevar ' + restante + ' más.';
    } else if (v.q <= 10) {
      aviso.className = v.q <= 5 ? 'sst sst--pocas' : 'sst sst--info';
      aviso.textContent = (v.q <= 5 ? '¡Quedan solo ' : 'Quedan ') + v.q + ' ' + unidades(v.q) + ' disponibles!';
    } else {
      aviso.textContent = '';   // con bastante stock no hace falta el aviso
    }
  }

  function limitar(desdeElCliente) {
    var v = datos();
    if (!limitado(v) || v.q <= 0) {
      input.removeAttribute('max');
      if (boton) boton.disabled = false;
      pintar(v, 99, false);
      return;
    }
    var restante = v.q - (enCarrito[idActual()] || 0);
    input.setAttribute('max', Math.max(1, restante));
    var n = parseInt(input.value, 10) || 1;
    var ajustado = false;
    if (restante > 0 && n > restante) { input.value = restante; ajustado = true; avisoHasta = Date.now() + 5000; }
    if (boton) boton.disabled = restante <= 0;
    pintar(v, restante, (ajustado || Date.now() < avisoHasta) && desdeElCliente !== false);
  }

  function leerCarrito() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        enCarrito = {};
        (c.items || []).forEach(function (i) { enCarrito[String(i.variant_id)] = (enCarrito[String(i.variant_id)] || 0) + i.quantity; });
        limitar(false);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () { if (input.value !== '') limitar(true); });
  input.addEventListener('change', function () { limitar(true); });
  // Los botones + / − del tema cambian el valor sin disparar "input"
  selector.addEventListener('click', function () { setTimeout(function () { limitar(true); }, 20); });
  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') return;
    setTimeout(function () { limitar(false); }, 60);
  });
  document.addEventListener('variant:changed', function () { setTimeout(function () { limitar(false); }, 60); });
  ['product:added', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.documentElement.addEventListener(ev, function () { setTimeout(leerCarrito, 400); });
    document.addEventListener(ev, function () { setTimeout(leerCarrito, 400); });
  });

  limitar(false);
  leerCarrito();
})();
